//切片上传
import axios from "axios"
export default {
    uploadAsync: async (data) => {
        return axios.post('/breakpoint_upload', data)
            .then((response) => response)
            .catch((error) => {
                console.log(error);
            });
    },
}
